import {DependencyList, useEffect} from "react";
import {EventPrefix} from "../constants";

export function useEvent<T>(
  eventName: string,
  eventHandler: (data: T) => void,
  deps?: DependencyList
): void {

  useEffect(() => {
    const handleEvent:EventListener = (event: Event) => {
      const data = (event as CustomEvent).detail
      eventHandler(data)
    }
    document.addEventListener(EventPrefix+eventName, handleEvent, false)
    return () => {
      document?.removeEventListener(EventPrefix+eventName, handleEvent, false)
    }
  }, deps)
}